// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"bfe05d55","372":"c1e8bf32","461":"804e64f9","480":"c89c3e5e","508":"614a18f7","602":"47d86ec2"}[chunkId] + ".chunk.css";
};